module.exports = fox._r("images/act-img-edit.png", __webpack_public_path__ + "_/_/_/common/frame/images/act-img-edit.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/act-img-edit.png
// module id = 135
// module chunks = 2